const style = {
  wrapper: {
    border: `1px solid #666`
  },
  label: {
    color: `black`
  },
  value: {
    color: `black`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Statistics/style/ColorBlind/cpm.js